import { doc, getFirestore, updateDoc } from "@firebase/firestore";
import { groupsTypes } from "../../Types/groups";

export async function TerminateActivateGroupUpdate(
    groupID: string,
    userData: Partial<groupsTypes>
  ) {
    const groupRef = doc(getFirestore(), "groups", groupID);
    await updateDoc(groupRef, userData);
  }